/** Shared with we-tree marketing site — keep storage keys in sync. */
export const CONSENT_STORAGE_KEY = 'wetree:consent:v1';
export const CONSENT_COOKIE_NAME = 'wetree_consent';
export const CONSENT_VERSION = 1 as const;
export const CONSENT_COOKIE_MAX_AGE_DAYS = 365;
export const CONSENT_CHANGED_EVENT = 'wetree:consent-changed';

export {
  getCookiesPolicyUrl,
  getMarketingSiteUrl,
  getPrivacyPolicyUrl,
  getRefundPolicyUrl,
  getTermsUrl,
  marketingLinkProps
} from '@/config/marketingSite';
